module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"th":{"warranty_duration.display":"รับประกัน {count} @:common.day","warranty_duration.display.zero":"ไม่ระบุระยะเวลารับประกัน","additional_warranty.flight.display":"ชั่วโมงบินไม่เกิน {count} @:common.hour","additional_warranty.charge.display":"ชาร์ตไม่เกิน {count} @:common.charge.unit"}}')
  delete Component.options._Ctor
}
